// in ./ResetViewsButton.js
import * as React from "react";
import { Link } from 'react-router-dom';
import {
    Button,
    useUnselectAll,
} from 'react-admin';
import { Redirect } from 'react-router-dom';
import JobIcon from '@material-ui/icons/Assignment';

const ButtonCreateJob = ({ selectedIds, label }) => {
    const unselectAll = useUnselectAll('hydrants');
    console.log(`label: ${label}`);
    unselectAll();
    return (      
      <Button
        component={Link}
        label='Create OTA Job'
        onClick= { console.log('clicked!!!')}
        to={`/jobs/create?id=${selectedIds}`}
      >
          <JobIcon />
      </Button>
    );
};

export default ButtonCreateJob;